// TanStack Query factory — apps crean propio queryClient (v0.2.0)
// Zero singleton export — pattern consistency con createApiClient

import { QueryClient, type QueryClientConfig } from '@tanstack/react-query'

/**
 * Create QueryClient instance con defaults razonables + override opcional.
 *
 * @example
 * ```ts
 * export const queryClient = createQueryClient()
 * // o con override:
 * export const queryClient = createQueryClient({
 *   defaultOptions: { queries: { staleTime: 10 * 60 * 1000 } }
 * })
 * ```
 */
export function createQueryClient(overrides?: QueryClientConfig): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 5 * 60 * 1000, // 5min
        gcTime: 10 * 60 * 1000, // 10min
        retry: (failureCount, error) => {
          // No retry en 4xx (errors cliente)
          if (error instanceof Error && 'status' in error) {
            const status = (error as Error & { status: number }).status
            if (status >= 400 && status < 500) return false
          }
          return failureCount < 3
        },
        refetchOnWindowFocus: false, // explicit opt-in per query
      },
      mutations: {
        retry: 0, // no retry mutations by default
      },
      ...overrides?.defaultOptions,
    },
    ...overrides,
  })
}
